<template>
  <div
    ref="overlayEle"
    class="sd-overlay"
  >
    <slot />
  </div>
</template>

<script>
import Overlay from 'ol/Overlay.js'
export default {
  name: 'SdOverlay',
  props: {
    coordinate: {
      type: Array,
      default() {
        return null
      }
    },
    props: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      map_: null,
      overlay_: null,
      props_: {}
    }
  },
  watch: {
    coordinate(val) {
      if (this.overlay_) {
        this.overlay_.setPosition(val)
      }
    }
  },
  destroyed() {
    this.unMap()
  },
  methods: {
    setMap(map) {
      this.map_ = map
      this.initMap(map)
    },
    initMap(map) {
      this.props_ = Object.assign(this.props, { element: this.$refs.overlayEle })
      this.overlay_ = new Overlay(this.props_)
      map.addOverlay(this.overlay_)
    },
    unMap() {
      this.map_?.removeOverlay(this.overlay_)
    }
  }
}
</script>

<style scoped>
.sd-overlay {
  z-index: 100;
}
</style>
